import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';
import {SIGNPOST_SIGN} from 'src/app/modules/route-planner/enums/route.enum';

@Component({
    selector: 'aa-primary-road-signpost',
    templateUrl: './aa-primary-road-signpost.component.html',
    styleUrls: ['./aa-primary-road-signpost.component.scss'],
    standalone: false
})
export class AaPrimaryRoadSignpostComponent {

  @Input() road: Array<Road>;
  aa_type_place_of_interest = SIGNPOST_SIGN.PLACE_OF_INTEREST_SIGN;
  aa_type_primary_road = SIGNPOST_SIGN.PRIMARY_ROAD_SIGN;
  aa_type_motarway = SIGNPOST_SIGN.MOTORWAY_SIGN;
  aa_local_roadway = SIGNPOST_SIGN.LOCAL_ROAD_SIGN;

  constructor() { }

  get roads() {
    return this.road;
  }

  getClassName(name) {
    return (name.indexOf('M') !== -1) ? 'signspot-motorway' : 'signspot-a-road';
  }
  
  trackByFn(index: number): number {
    return index;
  }

}
